import React, { useState, useEffect } from 'react';
import styles from './MasterData.module.css';
import axios from 'axios';
import { API } from '../../../config/API';
import DataTable from "react-data-table-component";
import Modal from '../../../components/Modal/Modal';
import modalLogo from '../../../assets/AppName.png'
import Loader from '../../../components/Loader/Loader';
import ToastComp from '../../../components/Toast/Toast';
import toast from 'react-hot-toast';

// prop: options = { showDetails: true, showHeader: false, ... }
export default function MasterData(props) {

  const [isModalOpen, setModalOpen] = useState(false);
  const [levelModalOpen, setLevelModalOpen] = useState(false);
  const [deptModalOpen, setDeptModalOpen] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [levelName, setLevelName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  // const [toast, setToast] = useState({ show: false, type: '', message: '' });
  const [projectData, setProjectData] = useState([]);
  const [levelData, setLevelData] = useState([]);
  const [deptData, setDeptData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    // This effect runs when the component mounts 
    getMasterDataList();
    getDepartmentData();
  }, []);


  const getMasterDataList = async () => {
    try {
      setLoading(true);
      axios.get(API.getMasterData)
        .then((response) => {
          setLoading(false);
          if (response.status === 200 && response.data.status === 'S') {
            // console.log("Master data list fetched successfully:", response.data);
            // Here you can set the data to state if needed
            setProjectData(response.data.projects || []);
            setLevelData(response.data.levels || []);
            // setDeptData(response.data.departments || []);

          } else {
            console.error("Failed to fetch master data list:", response.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching master data list:", error);
        });
    }
    catch (error) {
      setLoading(false);
      console.error("Error fetching master data list:", error);
    }
  }

  const getDepartmentData = async () => {
    try {
      setLoading(true);
      const result = await axios.get(API.getDepartmentData);
      console.log(result);
      if (result.status === 200) {
        setDeptData(result.data || []);
      } else {
        console.error("Failed to fetch department data:", result.data.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching department data:", error);
    }
  }

  // Function to open the modal
  const openModal = (type) => {
    if (type === 'project') setModalOpen(true);
    if (type === 'level') setLevelModalOpen(true);
    if (type === 'department') setDeptModalOpen(true);
  };

  // Function to close the modal
  const closeModal = (type) => {
    if (type === 'project') setModalOpen(false);
    if (type === 'level') setLevelModalOpen(false);
    if (type === 'department') setDeptModalOpen(false);
  };

  const columns = [
    {
      name: 'Project Id',
      selector: row => row.id,
      sortable: true,
    },
    {
      name: 'Project Name',
      selector: row => row.value,
      sortable: true,
    },

  ];

  const levelColumns = [
    {
      name: 'Level Id',
      selector: row => row.id,
      sortable: true,
    },
    {
      name: 'Level Name',
      selector: row => row.value,
      sortable: true,
    },

  ];

  const deptColumns = [
    {
      name: 'Department Id',
      selector: row => row.id,
      sortable: true,
    },
    {
      name: 'Department Name',
      selector: row => row.name,
      sortable: true,
    },

  ];

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#1C2556",
        color: "white"
      }
    }
  }

  console.log("MasterData component mounted with type:", props.type);
  const { type } = props;



  const handleCreateProject = async () => {
    try {
      const body = {
        type: 2,
        value: projectName
      }
      console.log(body);
      setLoading(true);
      const result = await axios.post(API.createMasterData, body);
      setLoading(false);
      console.log(result);
      if (result.status == 200 || result.data.status == 'S') {
        // setShowAlert(true);
        toast.success('Project created successfully!');
        closeModal('project');
        setProjectName("");
        getMasterDataList(); 
      } else {
        console.error("Failed to create project:", result.data.message);
        // setToast({ show: true, type: 'error', message: 'Failed to create project.' });
        toast.error('Failed to create project.');
        return;
      }
      // setToast({ show: true, type: 'success', message: 'Project created successfully!' });
      // setProjectName("");
      // setModalOpen(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      // setToast({ show: true, type: 'error', message: 'Failed to create project.' });
    }
  }

  const handleCreateLevel = async () => {
    try {
      const body = {
        type: 1,
        value: levelName
      }
      // console.log(body);
      setLoading(true);
      const result = await axios.post(API.createMasterData, body);
      console.log(result);
      setLoading(false);
      if (result.status == 200 || result.data.status == 'S') {
        // setShowAlert(true);
        toast.success('Level created successfully!');
        closeModal('level');
        setLevelName("");
        getMasterDataList(); 
      } else {
        console.error("Failed to create level:", result.data.message);
        // setToast({ show: true, type: 'error', message: 'Failed to create level.' });
        toast.error('Failed to create level.');
        return;
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  const handleCreateDepartment = async () => {
    try {
      const body = {
        name: departmentName
      }
      // console.log(body);
      setLoading(true);
      const result = await axios.post(API.departmentData, body);
      console.log(result);
      setLoading(false);
      if (result.data.status == 'S') {
        // setShowAlert(true);
        toast.success('Department created successfully!');
        closeModal('department');
        setDepartmentName("");
        getDepartmentData(); 
      } else {
        // console.error("Failed to create department:", result.data.message);
        // setToast({ show: true, type: 'error', message: 'Failed to create department.' });
        toast.error('Failed to create department.');
        return;
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  return (
    <div>
      {/* {showAlert ?
        <ToastComp
          case="add-project"
          handler={() => {
            setShowAlert(false);
          }}
        /> : ''
      } */}

      <Loader loading={loading} />
      <div className={`overflow-auto ${styles.bread_crumb}`}>
        <span className='breadcrumb-title'>
          <input type='button' className='btn'
            value={type === 'project' ? 'Projects' :
              type === 'level' ? 'Level' :
                type === 'department' ? 'Department' : ''}
          ></input>
        </span>
      </div>

      <div className={styles.master_data_container}>
        {type === 'project' && (
          <div className={styles.masterDataProject}>
            <div className={styles.header_wrapper}>
              <h2></h2>
              <button onClick={() => openModal('project')}>Create</button>
            </div>

            <Modal
              isOpen={isModalOpen}
              onClose={() => closeModal('project')}
            >
              <div className={styles.project_form_container}>
                <div className={styles.form_input_wrapper}>
                  <label htmlFor="">Project Name</label>
                  <input type="text" name="projectName" value={projectName} onChange={(e) => setProjectName(e.target.value)} />
                </div>
                <button onClick={handleCreateProject}>Submit</button>
              </div>
            </Modal>
            {/* <p>Project-related master data goes here.</p> */}
            <div className={styles.table_container}>
              <DataTable
                columns={columns}
                // defaultSortFieldId="id"
                data={projectData}
                pagination
                striped
              />
            </div>
          </div>
        )}
        {type === 'level' && (
          <div className={styles.master_data_level}>
            <div className={styles.header_wrapper}>
              <h2></h2>
              <button onClick={() => openModal('level')}>Create</button>
            </div>
            <Modal
              isOpen={levelModalOpen}
              onClose={() => closeModal('level')}
            >
              <div className={styles.project_form_container}>
                <div className={styles.form_input_wrapper}>
                  <label htmlFor="">Level Name</label>
                  <input type="text" name="levelName" value={levelName} onChange={(e) => setLevelName(e.target.value)} />
                </div>
                <button onClick={handleCreateLevel}>Submit</button>
              </div>
            </Modal>
            {/* <p>Level-related master data goes here.</p> */}
            <div className={styles.table_container}>
              <DataTable
                columns={levelColumns}
                // defaultSortFieldId="id"
                data={levelData}
                pagination
                striped
              />
            </div>
          </div>
        )}
        {type === 'department' && (
          <div className={styles.master_data_department}>
            <div className={styles.header_wrapper}>
              <h2></h2>
              <button onClick={() => openModal('department')}>Create</button>
            </div>
            <Modal
              isOpen={deptModalOpen}
              onClose={() => closeModal('department')}
            >
              <div className={styles.project_form_container}>
                <div className={styles.form_input_wrapper}>
                  <label htmlFor="">Department Name</label>
                  <input type="text" name="departmentName" value={departmentName} onChange={(e) => setDepartmentName(e.target.value)} />
                </div>
                <button onClick={handleCreateDepartment}>Submit</button>
              </div>
            </Modal>
            {/* <p>Department-related master data goes here.</p> */}
            <div className={styles.table_container}>
              <DataTable
                columns={deptColumns}
                // defaultSortFieldId="id"
                data={deptData}
                pagination
                striped
              />
            </div>
          </div>
        )}

      </div>
      {/* <ToastComp
        show={toast.show}
        type={toast.type}
        message={toast.message}
        onClose={() => setToast({ ...toast, show: false })}
      /> */}
    </div>
  )
}
